import { render, staticRenderFns } from "./catalog-filter.vue?vue&type=template&id=0f17a831"
import script from "./catalog-filter.vue?vue&type=script&lang=js"
export * from "./catalog-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports